<template>
  <div id="view-container">
    <p class="text-center mapText">
      <v-row>
        <v-col cols="12">
          <h1>
            {{ $t(`message.slideSeventeenTitle`) }}
          </h1>
          <h2>
            {{ $t(`message.slideSeventeenSubTitle`) }}
          </h2>
          <span style="font-size: x-large; padding-bottom: 3%">
            {{ $t(`message.slideSeventeenInstructions`) }}
          </span>
          <v-row>
            <v-col
              :cols="colSize"
              :class="$vuetify.breakpoint.xs ? `` : `text-left`"
            >
              <v-btn
                class="white--text"
                color="#015594"
                @click="toggleCriteria = true"
              >
                {{ $t(`message.CriteriaBtn`) }}
              </v-btn>
            </v-col>
            <v-col
              :cols="colSize"
              :class="$vuetify.breakpoint.xs ? `` : `text-right`"
            >
              <v-btn
                class="white--text"
                color="#015594"
                @click="toggleFactors = true"
              >
                {{ $t(`message.slideSeventeenPlanningFactorsBtn`) }}
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row>
        <v-col :cols="mapColSize">
          <v-divider></v-divider><br />
          <div
            id="exercise5View"
            ref="locationsMap"
            :class="
              $vuetify.breakpoint.xs ? `locationsMapMobile` : `locationsMap`
            "
          />
          <v-divider></v-divider><br />
        </v-col>
        <v-col :cols="mapPointsTextFieldsColSize">
          <span
            v-if="this.hasPins"
            style="font-size: x-large; padding-bottom: 2%"
          >
            {{ $t(`message.slideNinePinCommentInstructions`) }}
          </span>
          <v-divider></v-divider><br />
          <v-text-field
            v-for="(point, index) in finalPayload[`EX5`]"
            :key="point.uid"
            outlined
            :label="getLabel(index)"
            v-model="point.pointComment"
            :append-icon="'mdi-delete'"
            @click:append="deletePin(point.uid)"
            style="margin-bottom: 2.5%;"
            @change="updatePointText(point)"
          />
        </v-col>
      </v-row>
    </p>
    <div id="remove-points3" class="esri-widget">
      <button id="resetButton3" type="button">
        Remove all points
      </button>
    </div>
    <v-dialog v-model="toggleCriteria">
      <div class="text-right" style="background: antiquewhite;">
        <v-btn class="text-right" @click="toggleCriteria = false">X</v-btn>
      </div>
      <v-card style="padding: 2.5%">
        <h1>{{ $t(`message.CriteriaDialogTitle`) }}</h1>
        <br />
        <FourteenCriteria />
      </v-card>
    </v-dialog>
    <v-dialog v-model="toggleFactors">
      <div class="text-right" style="background: antiquewhite;">
        <v-btn class="text-right" @click="toggleFactors = false">X</v-btn>
      </div>
      <v-card style="padding: 2.5%">
        <h1>{{ $t(`message.slideSeventeenPlanningFactorsDialogTitle`) }}</h1>
        <br />
        <p>
          {{ $t(`message.slideSeventeenPlanningFactorsDialogDetails`) }}
        </p>
        <br />
        <PlanningFactors />
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { loadModules } from "esri-loader";
import { mapState, mapActions } from "vuex";
import FourteenCriteria from "@/components/FourteenCriteria.vue";
import PlanningFactors from "@/components/PlanningFactors.vue";

export default {
  // props: {
  //   file: { type: String },
  //   slideNumber: { type: Number }
  // },
  components: {
    FourteenCriteria,
    PlanningFactors
  },
  props: {
    file: { type: String },
    slideNumber: { type: Number },
    updateFile: { type: Function }
  },
  data() {
    return {
      view: null,
      toggleCriteria: false,
      toggleFactors: false,
      audio: null
    };
  },
  watch: {
    slideNumber(current) {
      this.newSlideNumber = current;
      if (current !== 16) {
        this.audio.pause();
        this.audio.currentTime = 0;
      } else {
        this.audio = new Audio(this.file);
        this.audio.play();
      }
    },
    "$i18n.locale": function() {
      if (this.newSlideNumber === 16) {
        this.audio.pause();
        this.audio.currentTime = 0;
        this.updateFile(16);
        this.audio = new Audio(this.file);
        this.audio.play();
      }
    }
  },
  mounted() {
    this.newSlideNumber = this.slideNumber;
    this.audio = new Audio(this.file);
    this.audio.play();
    /* eslint-disable */
    const options = { version: "4.12", css: true }; // explicitly set API version to avoid future breaking changes
    loadModules(["esri/Map", "esri/Graphic", "esri/widgets/Locate", "esri/views/MapView", "esri/widgets/Home", "esri/layers/FeatureLayer"], options)
    .then(([Map, Graphic, Locate, MapView, Home, FeatureLayer]) => {
    const map = new Map({
        basemap: "streets-vector"
    });
    this.view = new MapView({
      map: map,
      container: "exercise5View",
      center: [-106.446, 31.810],
      zoom: 10,
      ui: {
        components: ["attribution"],
      },
    });
    const button = new Home({
        view: this.view
    });
    const locate = new Locate({
        view: this.view
    });
    this.view.ui.add(button, "bottom-left");
    this.view.ui.add(locate, "bottom-left");
    this.view.ui.add("remove-points3", "bottom-trailing");
    const reset = () => {
        this.view.graphics.removeAll();
        this.setMapConcerningPoints({exercise: `EX5`, points: []})
    };
    document.getElementById("resetButton3").onclick = reset;
    this.view.on("click", event => {
        const coords = this.view.toMap({ x: event.x, y: event.y });

        const point = {
            type: "point",
            longitude: coords.longitude,
            latitude: coords.latitude
        };
        let pointGraphic = new Graphic({
            geometry: point,
            symbol: {
                type: "picture-marker",
                width: 30,
                height: 30,
                url: "https://static.arcgis.com/images/Symbols/Basic/RedStickpin.png",
            }
        });

        this.view.graphics.add(pointGraphic)
        const coordsItems = this.view.graphics._items.map(item => {
          const existingItem = this.finalPayload[`EX5`].find(p => p.uid === item.uid)
          if (existingItem) {
            return {
              x: item.geometry.x,
              y: item.geometry.y,
              uid: item.uid,
              pointComment: existingItem.pointComment
            }
          } else {
            return {
              x: item.geometry.x,
              y: item.geometry.y,
              uid: item.uid,
              pointComment: ""
            }
          }
        });
        this.setMapConcerningPoints({exercise: `EX5`, points: coordsItems})
    });
    })
    .catch(err => {
        console.error(err);
    });   
    },
  computed: {
    ...mapState("response", ["finalPayload"]),
       hasPins() {
      return this.finalPayload[`EX5`].length !== 0
    },
    mapColSize() {
      if (this.$vuetify.breakpoint.xs) {
        return "12"
      } else if (this.hasPins) {
        return "8";
      }
      return "12";
    },
    mapPointsTextFieldsColSize() {
      if (this.$vuetify.breakpoint.xs && this.hasPins) {
        return "12"
      } else if (this.hasPins) {
        return "4";
      }
      return "0";
    },
    colSize() {
      if (this.$vuetify.breakpoint.xs) {
        return "12"
      } 
      return "6"
    }
  },
  methods: {
    ...mapActions('response', ["updateMapPointTexts", "setMapConcerningPoints", "deletePointFromMap"]),
    deletePin(pinUID) {
      this.deletePointFromMap({exercise: `EX5`, uid: pinUID}) 
      const graphicToRemove = this.view.graphics._items.find(
        item => item.uid == pinUID
      );
      this.view.graphics.remove(graphicToRemove);
    },
    getLabel(index) {
      return this.$t(`message.slideNinePinCommentFieldLabel`) + ` ${(parseInt(index) + 1)}:`
    },
    updatePointText(point) {
      point.exercise = `EX5`
      this.updateMapPointTexts(point)
    },
  }
}
</script>
<style>
.locationsMap {
  height: 800px;
}
.locationsMapMobile {
  height: 400px;
}
.mapText {
  margin: 0% !important;
}
#resetButton3 {
    padding: 3%;
}
</style>